export default __webpack_public_path__ + "static/media/k16.02cdd9f0.jpg";